import React from "react";
import "../FlightRoster.css";
import FlightRosterCardComponent from "./FlightRosterCardComponent";
import Loader from "../../../../components/element/Loader";
import NoDataPlaceholder from "../../../../components/element/NoDataPlaceholder";
import ErrorPopup from "../../../../components/element/ErrorPopup";

const FlightRosterGridComponent = ({
  isAAUser,
  flightPlanData,
  onClickCard,
  isLoading,
  error,
  airlineNames,
  isDisputeTab = false,
}) => {
  if (error) {
    if (error.status === 404) {
      return <NoDataPlaceholder />;
    } else {
      return <ErrorPopup children={error.message}></ErrorPopup>;
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  if (flightPlanData && flightPlanData.data.content.length === 0) {
    return <NoDataPlaceholder />;
  }

  const cards = flightPlanData?.data?.content || [];
  const columns = 3;
  const rowHasVerification = {};

  cards.forEach((item, index) => {
    const rowIndex = Math.floor(index / columns);
    const hasVerificationIcon =
      isAAUser && (item?.adsbVerified || item?.bmsVerified);

    if (hasVerificationIcon) {
      rowHasVerification[rowIndex] = true;
    }
  });

  return (
    <div className="flight-roster-grid-container">
      {cards.map((item, index) => {
        const rowIndex = Math.floor(index / columns);
        return (
          <FlightRosterCardComponent
            key={index}
            isAAUser={isAAUser}
            item={item}
            onClickCard={() => onClickCard(item)}
            airlineNames={airlineNames}
            isDisputeTab={isDisputeTab}
            rowHasVerification={!!rowHasVerification[rowIndex]}
          />
        );
      })}
    </div>
  );
};

export default FlightRosterGridComponent;
